
import debounce from 'lodash/debounce';
import { mmMatches } from '../utils/utils.matchmedia';
import Siema from 'siema';

function disableButton(button) {
    if(button) {
        button.classList.add('is-disabled');
        button.disabled = true;
    }
}

function enableButton(button) {
    if(button) {
        button.classList.remove('is-disabled');
        button.disabled = false;
    }
}

function setHeightOfCurrentItem(carousel) {
    carousel.sliderFrame.style.overflow = 'hidden';
    carousel.sliderFrame.style.height = carousel.innerElements[carousel.currentSlide].clientHeight + 'px';
}

const 	featuredContent = [...document.querySelectorAll('.js-featured-content-carousel')];

featuredContent.forEach( item => {

    const   featuredContentWrapper = item.querySelector('.js-featured-content-carousel-wrapper'),
            items = featuredContentWrapper.children.length;

    if ( featuredContentWrapper.children.length > 1 ) {
        const   arrowWrapper = item.querySelector('.js-next-prev-buttons'),
                prevButton = item.querySelector('.js-prev'),
                nextButton = item.querySelector('.js-next');

        const  featuredContentCarousel = new Siema({
            selector: featuredContentWrapper,
            duration: 200,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: false,
            multipleDrag: true,
            threshold: 20,
            loop: false,
            onInit: () => {
                featuredContentWrapper.classList.add('is-carousel');
            },
            onChange: () => {

                if(featuredContentCarousel.currentSlide > 0) {
                    enableButton(prevButton);
                } else {
                    disableButton(prevButton);
                }

                if(featuredContentCarousel.currentSlide + 1 == items) {
                    disableButton(nextButton);
                } else {
                    enableButton(nextButton);
                }

                // set height to current slide height
                setHeightOfCurrentItem(featuredContentCarousel);
            }
        });

        arrowWrapper.classList.remove('is-hidden');

        prevButton.addEventListener('click', e => {
            featuredContentCarousel.prev();
        });
        nextButton.addEventListener('click', e => {
            featuredContentCarousel.next();
        });

        setHeightOfCurrentItem(featuredContentCarousel);

        window.addEventListener('resize', debounce( (e) => {
            setHeightOfCurrentItem(featuredContentCarousel);
        }, 20 ));
    }
    
});


